// Arqum 2026-10-08.
(() => {
  const names = new Set(['shown', 'scratch_started', 'code_revealed', 'code_copied', 'shop_clicked']);
  const active = new Set();
  const allowed = () => {
    try { const privacy = window.Shopify && window.Shopify.customerPrivacy; return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true); }
    catch (error) { return false; }
  };
  const resumeVisible = () => active.forEach(resume => resume());
  document.addEventListener('visitorConsentCollected', resumeVisible);
  document.addEventListener('visibilitychange', resumeVisible);
  window.IPSOfferMeasurement = {
    create(root) {
      if (!['qa', 'live'].includes(root.dataset.measurementScope)) return null;
      const params = new URLSearchParams(location.search);
      const qa = root.dataset.measurementScope === 'qa' || root.dataset.preview === 'true' || params.has('preview_theme_id') || params.get('ips_measurement_qa') === '1';
      const prefix = qa ? 'ips_offer_qa_' : 'ips_offer_';
      const dialog = root.querySelector('dialog');
      if (!dialog) return null;
      let opening = null;
      const visible = () => dialog.hasAttribute('open') && document.visibilityState !== 'hidden';
      function send(name) {
        if (!opening || !visible() || !allowed() || typeof window.clarity !== 'function' || opening.issued.has(name)) return false;
        opening.issued.add(name);
        try { return window.clarity('event', prefix + opening.offer + '_' + name) !== false; }
        catch (error) { return false; }
      }
      function shown() {
        if (!opening) return false;
        if (!opening.shownAccepted) opening.shownAccepted = send('shown');
        return opening.shownAccepted;
      }
      active.add(shown);
      return {
        begin(offer) {
          opening = offer === 'delivery' ? {offer, issued:new Set(), shownAccepted:false} : null;
          shown();
        },
        record(name) {
          if (!names.has(name) || !shown()) return false;
          if (name === 'shown') return true;
          return send(name);
        }
      };
    }
  };
  try {
    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => { if (!error) resumeVisible(); });
  } catch (error) {}
})();
